module.exports = __webpack_public_path__ + "static/media/DangerCompany.7fd8e109.svg";